import styled from 'styled-components';

export const Container = styled.div`
  width: 85%;
  margin: 0 auto;
  background-color: #c4cfd8;
  display: inline-block;
  background: #f3f6f5;
  border: 0 none;
  border-radius: 0px;
  padding: 30px 40px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.1);
  font-size: 1.2rem;
  @media (max-width: 1024px){
    width: 100%;
  }
  @media (max-width: 576px) {
    font-size: 0.9rem;
  }
`;